import { render, staticRenderFns } from "./TransferSearch.vue?vue&type=template&id=0f03d8d6&scoped=true"
import script from "./TransferSearch.vue?vue&type=script&lang=js"
export * from "./TransferSearch.vue?vue&type=script&lang=js"
import style0 from "./TransferSearch.vue?vue&type=style&index=0&id=0f03d8d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f03d8d6",
  null
  
)

export default component.exports